import React, {useEffect} from "react";
import {useLocation} from "react-router";
import {data} from "../../data/data";
import {useNavigate} from "react-router-dom";
import Logo from "../../components/Logo";
import { RotatingLines } from "react-loader-spinner";
import { useTranslation } from "react-i18next";

export function Home() {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const sessionData = new URLSearchParams(location.search).get('sessionData');
  const sessionId = new URLSearchParams(location.search).get('id');

  useEffect(() => {
    const errorPath = `/status/error?reason=${encodeURI(t('invalid session'))}`;
    data.session = {
      sessionData: sessionData || '',
      id: sessionId || ''
    };
    fetch('/config.json').then((response) => {
      if (response.ok) {
        response.json().then((body) => {
          data.config = body
          navigate(`/payment/`, { replace: true });
        }).catch(() => {
          navigate(errorPath, { replace: true });
        });
      } else {
        navigate(errorPath, { replace: true });
      }
    }).catch(() => {
      navigate(errorPath, { replace: true });
    });
  });

  return <div id="payment-page">
  <div className="outer">
    <Logo />
    <div className="inner">
      <RotatingLines
        strokeColor="#000"
        strokeWidth="5"
        animationDuration="0.75"
        width="96"
        visible={true}
      />
    </div>
  </div>
</div>;
}
